export default __webpack_public_path__ + "images/flags/hu.png?8055e6b2fd9c41b7ec1f0742e564842187a2239bc09c2610fc10ac9873db1537";